import { render, staticRenderFns } from "./performance-brand-report.vue?vue&type=template&id=3f48b891&scoped=true"
import script from "./performance-brand-report.vue?vue&type=script&lang=js"
export * from "./performance-brand-report.vue?vue&type=script&lang=js"
import style0 from "./performance-brand-report.vue?vue&type=style&index=0&id=3f48b891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48b891",
  null
  
)

export default component.exports